import $ from 'jquery';
import * as THREE from 'three';
import * as TWEEN from 'tween.js';

import Config from '../config';
import { formatNumber, cleanURLString } from '../utils';
import * as CountryDataHelpers from '../utils/countryDataHelpers';
import { worldMap } from './index.js';
import * as Panels from './panel';
import { log } from '../LogTerminal';
import { lte } from 'lodash';



export const mouse = new THREE.Vector2();
export const mouseNormalized = new THREE.Vector3( 0, 0, 1 );
export const mouseNormalizedTouchStart = new THREE.Vector3( 0, 0, 1 );

var selectCountryOnTouchEnd = true;
var isMouseDown = false;
var countryListSorting = '';
var uiReady = false;



export function init(worldMap) {
  createLegend(worldMap);
  updateLegend();

  createCountryList(worldMap);
  updateCountryList(worldMap);

  /* initViewSwitch(worldMap); */

  initGeneralElements(worldMap);

  bindEventHandlers();

  closeLoadingInfo();
};


export function completeInit() {
  uiReady = true;
};


export function createLegend(worldMap) {
  /*$('#legend_main .range .box').css('background', '#' + Config.colorCountryArrayDefault[0].getHexString());
  $('#legend_main .range .box').css('background', '-moz-linear-gradient(left,  #' + Config.colorCountryArrayDefault[0].getHexString() + ' 0%, #' + Config.colorCountryArrayDefault[10].getHexString() + ' 100%)');
  $('#legend_main .range .box').css('background', '-webkit-gradient(linear,left top,right top,from(#' + Config.colorCountryArrayDefault[0].getHexString() + '),to(#' + Config.colorCountryArrayDefault[10].getHexString() + '))');
  $('#legend_main .range .box').css('background', '-webkit-linear-gradient(left,  #' + Config.colorCountryArrayDefault[0].getHexString() + ' 0%,#' + Config.colorCountryArrayDefault[10].getHexString() + ' 100%)');
  $('#legend_main .range .box').css('background', '-o-linear-gradient(left,  #' + Config.colorCountryArrayDefault[0].getHexString() + ' 0%,#' + Config.colorCountryArrayDefault[10].getHexString() + ' 100%)');
  $('#legend_main .range .box').css('background', '-ms-linear-gradient(left,  #' + Config.colorCountryArrayDefault[0].getHexString() + ' 0%,#' + Config.colorCountryArrayDefault[10].getHexString() + ' 100%)');
  $('#legend_main .range .box').css('background', 'linear-gradient(to right,  #' + Config.colorCountryArrayDefault[0].getHexString() + ' 0%,#' + Config.colorCountryArrayDefault[10].getHexString() + ' 100%)');
  $('#legend_main .range .box').css('filter', 'progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#' + Config.colorCountryArrayDefault[0].getHexString() + '\', endColorstr=\'#' + Config.colorCountryArrayDefault[10].getHexString() + '\',GradientType=1 )');

  $('#legend_main .colors').append('<div class="color no-data"><div class="box" style="background-color: #' + Config.colorVisaDataNotAvailable.getHexString() + '"></div><div class="text">Special status/data not available</div></div>');

  $('#legend_selected .colors').append('<div class="color no-data"><div class="box" style="background-color: #' + Config.colorCountrySelected.getHexString() + '"></div><div class="text">Selected country/nationality</div></div>');
  $('#legend_selected .colors').append('<div class="color no-data"><div class="box" style="background-color: #' + Config.colorVisaNotRequired.getHexString() + '"></div><div class="text">Visa not required</div></div>');
  $('#legend_selected .colors').append('<div class="color no-data"><div class="box" style="background-color: #' + Config.colorVisaOnArrival.getHexString() + '"></div><div class="text">Visa on arrival</div></div>');
  $('#legend_selected .colors').append('<div class="color no-data"><div class="box" style="background-color: #' + Config.colorVisaETA.getHexString() + '"></div><div class="text">Electronic Travel Authorization</div></div>');
  $('#legend_selected .colors').append('<div class="color no-data"><div class="box" style="background-color: #' + Config.colorVisaFreeEU.getHexString() + '"></div><div class="text">EU freedom of movement</div></div>');
  $('#legend_selected .colors').append('<div class="color no-data"><div class="box" style="background-color: #' + Config.colorVisaSpecial.getHexString() + '"></div><div class="text">Special regulations</div></div>');
  $('#legend_selected .colors').append('<div class="color no-data"><div class="box" style="background-color: #' + Config.colorVisaAdmissionRefused.getHexString() + '"></div><div class="text">Admission refused</div></div>');
  $('#legend_selected .colors').append('<div class="color no-data"><div class="box" style="background-color: #' + Config.colorVisaRequired.getHexString() + '"></div><div class="text">Visa required</div></div>');
  $('#legend_selected .colors').append('<div class="color no-data"><div class="box" style="background-color: #' + Config.colorVisaDataNotAvailable.getHexString() + '"></div><div class="text">Data not available</div></div>');
 */
};


export function updateLegend() {
   if(worldMap.selectedMapType == 'companies') $('#legend_main').html('<div class="range">'
    +'<div class="box" style="background: #dddddd"></div>'
    +'<div class="box" style="background: #c0c0c0"></div>'
    +'<div class="box" style="background: #b0b0b0"></div>'
    +'<div class="box" style="background: #a0a0a0"></div>'
    +'<div class="box" style="background: #959595"></div>'
    +'<div class="box" style="background: #858585"></div>'
    +'<div class="box" style="background: #777777"></div>'
    +'<div class="box" style="background: #666666"></div>'
    +'<div class="box" style="background: #555555"></div>'
    +'<div class="box" style="background: #444444"></div>'
    +'<div class="box" style="background: #333333"></div>'
    +'<div class="rangelabel">Companies density</div>'
    +'</div>'
    +'<div class="colors"></div>');
  else if(worldMap.selectedMapType == 'opportunity') 
    $('#legend_main').html('<div class="range">'
    +'<div class="box" style="background: #dddddd"></div>'
    +'<div class="box" style="background: #ccd4cc"></div>'
    +'<div class="box" style="background: #bbd2bc"></div>'
    +'<div class="box" style="background: #a0cea1"></div>'
    +'<div class="box" style="background: #83ca89"></div>'
    +'<div class="box" style="background: #68c672"></div>'
    +'<div class="box" style="background: #4cc157"></div>'
    +'<div class="box" style="background: #30bd41"></div>'
    +'<div class="box" style="background: #0fb92a"></div>'
    +'<div class="box" style="background: #00900f"></div>'
    +'<div class="box" style="background: #00740c"></div>'
    +'<div class="rangelabel">Business opportunities</div>'
    +'</div>'
    +'<div class="colors"></div>');
  else if(worldMap.selectedMapType == 'risk') 
    $('#legend_main').html('<div class="range">'
    +'<div class="box" style="background: #dddddd"></div>'
    +'<div class="box" style="background: #d4cccc"></div>'
    +'<div class="box" style="background: #d6b7c6"></div>'
    +'<div class="box" style="background: #d49ab3"></div>'
    +'<div class="box" style="background: #d4789d"></div>'
    +'<div class="box" style="background: #d25c88"></div>'
    +'<div class="box" style="background: #d13c74"></div>'
    +'<div class="box" style="background: #d11d5e"></div>'
    +'<div class="box" style="background: #ce0248"></div>'
    +'<div class="box" style="background: #900035"></div>'
    +'<div class="box" style="background: #75002c"></div>'
    +'<div class="rangelabel">Business risks</div>'
    +'</div>'
    +'<div class="colors"></div>');
};

export function resetCompany() {
  $('#company .company').html('').hide();
  $('#company .clusterTitle').hide();
  $('#company .cluster').html('').hide();
}


export function showMainLegend() {
  $('#legend_main').fadeIn();
};


export function hideMainLegend() {
  $('#legend_main').fadeOut();
};

export function hideInitialMessage() {
  $('#company .initial').hide();
  $('#control > #globe-normal').show();
}

export function setSelectedCountry() {
  $('#button_country_list .title').html(worldMap.selectedCountry.name+' ('+worldMap.selectedCountry.pinArray.length+')');
  this.updateCountryInfo();
  this.createCityList(worldMap.selectedCountry);
  this.createCompanyList(worldMap.selectedCountry);
  this.hideInitialMessage();
  this.resetCompany();
  this.hideMainLegend();
}

export function setSelectedCity(count) {
  $('#button_city_list .title').html(worldMap.selectedCity+' ('+count+')');
  this.createCompanyList(worldMap.selectedCountry);
  this.resetCompany();
}

export function createCountryList(worldMap) {
  let $this = this;

  /* $(".chosen-select").on('change', function(evt, params) {
    if(oldSelected != params.selected) selectPin(params.selected);
  }); */

  var count = 0;
  var addHtml = '';

  worldMap.countries.sort(function(a, b) {
    var aName = a.name;
    var bName = b.name;
    return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
  });

  for(var i = 0; i < worldMap.countries.length; i++) {
    var country = worldMap.countries[i];
    var name = country.name;

    // if(name === 'United States') {
      // console.log(country.properties, CountryDataHelpers.isCountry(country), country.type === 'Country', country.sovereignt);
      // console.log(country.type);
    // }

    // add only proper countries:
    if(CountryDataHelpers.isCountry(country) && country.pinArray.length > 0) {
      var li = $('<li><div class="container"><span class="box"></span><span class="number"></span><span class="text">' + name + ' ('+country.pinArray.length+')</span></div></li>');
      $('#country_list').append(li);

      li.data('height', li.height());

      addHtml += '<optgroup label="'+name+'">';
      country.pinArray.forEach((pin) => {
        addHtml += '<option value="'+country.name+'|'+pin.marker.id+'">'+pin.info.name+'</option>';
      });
      addHtml += '</optgroup>';

      /*
      var width = parseInt(country.numDestinationsFreeOrOnArrival / worldMap.maxNumDestinationsFreeOrOnArrival * 200);
      var num = country.numDestinationsFreeOrOnArrival;
      if(country.destinations.length === 0) {
        num = "?";
      }
      li.find('.box').css('width', width + 'px');
      li.find('.box').css('background-color', '#' + country.colorByFreeDestinations.getHexString());
      li.find('.number').html(num);
      */

      li.data('country', country);
      country.listItem = li;
      count++;
    }
  }

  jQuery(document).ready(function($){
    $("#search").append('<option value="">Search a Company</option>'+addHtml).chosen({
      width: "100%"
    });

    $('#control > #globe-normal').on('click', function() {
      $('#search').val('').trigger('chosen:updated');
    });

    addHtml = null;

    $("#search").on('change', function(evt, params) {
      let values = params.selected.split('|');

      let selectedCountry = worldMap.countries.find(o => o.name === values[0]);
      if(selectedCountry != undefined) {
        let selectedPin = selectedCountry.pinArray.find((o) => { return o.marker.id == parseInt(values[1]); });
        if(selectedPin != undefined) {
          worldMap.setSelectedSearch(selectedCountry, selectedPin);
        }
      }

      $(this).trigger('chosen:updated');
    });
  });

  $('#country_list li').click(function(event) {
    var selectedCountryNew = $(this).data('country');

    if(worldMap.selectedCountry !== selectedCountryNew) {
      worldMap.setSelectedCountry(selectedCountryNew);
      $('#country_list').stop(true, true).slideToggle();
      $('#button_country_list .caret').css('-webkit-transform', 'rotate(0deg)');
    }

  });

  if(!Config.isTouchDevice) {
    $('#country_list li').hover(function() {
      if(!worldMap.introRunning) {
        var country = $(this).data('country');

        worldMap.listHover = true;
        worldMap.updateCountryHover(country);
      }

    }, function() {
      worldMap.listHover = false;

    });
  }

  $('#button_country_list').click(function(event) {
    if($('#city_list').is(':visible')) {
      $('#city_list').stop(true, true).slideToggle();
      $('#button_city_list .caret').css('-webkit-transform', 'rotate(0deg)');
    }

    if($('#company_list').is(':visible')) {
      $('#company_list').stop(true, true).slideToggle();
      $('#button_company_list .caret').css('-webkit-transform', 'rotate(0deg)');
    }

    if($('#country_list').is(':visible')) {
      $('#country_list').stop(true, true).slideToggle();
      $('#button_country_list .caret').css('-webkit-transform', 'rotate(0deg)');
    } else {
      $('#country_list').show();
      updateCountryList(worldMap);
      $('#country_list').hide();
      $('#country_list').stop(true, true).slideToggle();
      $('#button_country_list .caret').css('-webkit-transform', 'rotate(180deg)');
    }
  });

  $('#button_city_list').click(function(event) {
    if($('#company_list').is(':visible')) {
      $('#company_list').stop(true, true).slideToggle();
      $('#button_company_list .caret').css('-webkit-transform', 'rotate(0deg)');
    }

    if($('#city_list').is(':visible')) {
      $('#city_list').stop(true, true).slideToggle();
      $('#button_city_list .caret').css('-webkit-transform', 'rotate(0deg)');
    } else {
      $('#city_list').scrollTop(0);
      $('#city_list').stop(true, true).slideToggle();
      $('#button_city_list .caret').css('-webkit-transform', 'rotate(180deg)');
    }
  });

  $('#button_company_list').click(function(event) {
    if($('#company_list').is(':visible')) {
      $('#company_list').stop(true, true).slideToggle();
      $('#button_company_list .caret').css('-webkit-transform', 'rotate(0deg)');

    } else {
      $('#company_list').scrollTop(0);
      $('#company_list').stop(true, true).slideToggle();
      $('#button_company_list .caret').css('-webkit-transform', 'rotate(180deg)');
    }
  });

};

export function updateCountryList(worldMap) {
  // log('updateCountryList()');

  if($('#country_list').is(':visible')) {

    sortCountryListByName();
  }

  $('#country_list').scrollTop(0);

};


export function createCityList(country) {
  $('#city_list').html('');

  $('#button_city_list .title').html('Select a City');

  if(worldMap.cityList[country.name] !== undefined && worldMap.cityList[country.name].length !== 0) {
    worldMap.cityList[country.name].sort();
    if(worldMap.cityList[country.name]['All'] == null) worldMap.cityList[country.name].unshift('All');
    for(var i = 0; i < worldMap.cityList[country.name].length; i++) {
      var city = worldMap.cityList[country.name][i];

      let count = 0;
      if(city == 'All') count = country.pinArray.length;
      else {
        count = country.pinArray.filter(function(value) {
            if(value.info.city == city) return true;
            return false;
        });
        count = count.length;
      }

      var li = $('<li><div class="container"><span class="text">' + city + ' ('+count+')</span></div></li>');
      li.data('city', city);
      $('#city_list').append(li);
    }

    $('#city_list li').off('click');
    $('#city_list li').click(function(event) {
      var selectedCityNew = $(this).data('city');

      if(worldMap.selectedCity !== selectedCityNew) {
          worldMap.setSelectedCity(selectedCityNew);
          $('#city_list').stop(true, true).slideToggle();
          $('#button_city_list .caret').css('-webkit-transform', 'rotate(0deg)');
      }

    });

    if(!$('#select_city').is(':visible')) $('#select_city').show();
  }
};

export function createCompanyList(country) {
  $('#company_list').html('');

  let pinArray = country.pinArray;
  if(pinArray !== undefined &&  pinArray.length !== 0) {
    if(worldMap.selectedCity != null && worldMap.selectedCity != 'All') {
      pinArray = pinArray.filter(function(value) {
        if(value.info.city == worldMap.selectedCity) return true;
        return false;
      });
    }

    for(var i = 0; i < pinArray.length; i++) {
      var pin = pinArray[i];

      var li = $('<li><div class="container"><span class="text">' + pin.info.name + '</span></div></li>');
      li.data('pin', pin);
      $('#company_list').append(li);
    }

    $('#company_list li').off('click');
    $('#company_list li').click(function(event) {
      var selectedPinNew = $(this).data('pin');

      if(worldMap.selectedPin !== selectedPinNew) {
          worldMap.setSelectedPin(selectedPinNew);
          $('#company_list').stop(true, true).slideToggle();
          $('#button_company_list .caret').css('-webkit-transform', 'rotate(0deg)');
      }

    });

    if(!$('#select_company').is(':visible')) $('#select_company').show();

  }
  /* if(worldMap.selectedCity != null) {
    $('#button_company_list').click();
  } */

  pinArray = null;

};

export function selectedPinMap() {
  $('#city_list').stop(true, true).slideUp();
  $('#company_list').stop(true, true).slideUp();
  $('#button_company_list .caret').css('-webkit-transform', 'rotate(0deg)');
}

export function updateCompany(pin) {
  //$('#button_company_list .title').html(pin.name);

  if(!$('#company .company').is(':visible')) {
    $('#company .company').show();
    $('#company .clusterTitle').show();
    $('#company .cluster').show();
  }

  //$('#company .info').html('');
  $('#company .company').html('Company: '+pin.name+'<br/>Type: '+((pin.type == 0) ? 'Production facility' : 'Commercial establishment')+'<br/>City: '+pin.city+'<br/><span>'+pin.name_country+'</span>');
  $('#company .cluster').html(pin.cluster);
}


export function showCountryList(worldMap) {
  if($(window).width() > 480 && IS_DESKTOP) {
    if(!$('#country_list').is(':visible')) {
      updateCountryList(worldMap);
      $('#country_list').stop(true, true).slideToggle();
      $('#button_country_list .caret').css('-webkit-transform', 'rotate(180deg)');
    }
  }
}


function sortCountryListByName() {
  var newSorting = 'name';
  if(countryListSorting !== newSorting) {
    countryListSorting = newSorting;

    var li = $('#country_list').children('li');
    /* li.sort(function(a, b) {
      var aName = $(a).data('country').name;
      var bName = $(b).data('country').name;
      return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
    }); */
    repositionCountryList(li);
  }
}


function repositionCountryList(li) {
  var top = 0;

  if($('#country_list').is(':visible')) {
    $('#country_list li').css('transition', 'top 0.5s ease-out');
    li.each(function(i) {
      $(this).css('top', top + 'px');
      $(this).data('height', $(this).height());
      top += $(this).data('height');
    });
  } else {
    $('#country_list li').css('transition', 'none');
    li.each(function(i) {
      $(this).css('top', top + 'px');
      top += $(this).data('height');
    });
  }

}

export function updateCountryInfo() {
  if(worldMap.selectedMapType == 'companies') {
    $('#company #business-info').addClass('hide');
  } else if(worldMap.selectedMapType == 'opportunity') {
    $('#company #business-info').removeClass('hide');
    $('#company .business-type').html(worldMap.selectedCountry.name+' Business Opportunity');
    $('#company .info-link').attr('href', CDN_URL+'map-country.php?countryCode='+worldMap.selectedCountry.postal);
    $('#company .info').html('<ul><li><h3>Export opportunity index 2020</h3> '+worldMap.selectedCountry.opportunity.exopidx+'</li><li><h3>Investment opportunity index 2020</h3> '+worldMap.selectedCountry.opportunity.iopidx+'</li><li><h3>Trends in Italian exports 2020</h3> '+worldMap.selectedCountry.opportunity.aexp+'</li></ul>');
  } else if(worldMap.selectedMapType == 'risk') {
    $('#company #business-info').removeClass('hide');
    $('#company .business-type').html(worldMap.selectedCountry.name+' Business risks');
    $('#company .info-link').attr('href', CDN_URL+'map-country.php?countryCode='+worldMap.selectedCountry.postal);
    $('#company .info').html('<ul><li><h3>Sovereign credit risk</h3> '+worldMap.selectedCountry.risk.mpcs+'</li><li><h3>Bank credit risk</h3> '+worldMap.selectedCountry.risk.mpcb+'</li><li><h3>Corporate credit risk</h3> '+worldMap.selectedCountry.risk.mpcc+'</li></ul>');
  }
  this.updateLegend();
}

export function resetCountryInfo() {
  $('#company .info').html('');
}

export function initViewSwitch(worldMap) {
  $('#view_switch_flat').click(function(event) {
    $('#view_switch_flat').addClass('active');
    $('#view_switch_spherical').removeClass('active');

    worldMap.cameraUpdate = false;
    worldMap.controls.enabled = false;

    worldMap.globe.visible = false;

    worldMap.tweenSwitch = new TWEEN.Tween(worldMap.animationProps)
      .to({interpolatePos: 0.0}, Config.viewSwitchDuration)
      .onStart(function() {
        worldMap.hideDisputedAreasBorders();
      })
      .onUpdate(function() {
        worldMap.geometryNeedsUpdate = true;
        // worldMap.updateLines();
      })
      .onComplete(function() {
        //worldMap.controls = worldMap.controlsPinchZoom;
        worldMap.controls.enabled = true;
        worldMap.viewMode = '2d';
        worldMap.showDisputedAreasBorders();
      })
      .easing(TWEEN.Easing.Cubic.Out)
      .start();

    worldMap.tweenCameraPosition = new TWEEN.Tween(worldMap.camera.position)
      .to({ x: 0, y: 0, z: Config.cameraDistance }, Config.viewSwitchDuration)
      .easing(TWEEN.Easing.Cubic.Out)
      .start();

    worldMap.tweenCameraUp = new TWEEN.Tween(worldMap.camera.up)
      .to({ x: 0, y: 1, z: 0 }, Config.viewSwitchDuration)
      .easing(TWEEN.Easing.Cubic.Out)
      .start();

  });

  $('#view_switch_spherical').click(function(event) {
    $('#view_switch_spherical').addClass('active');
    $('#view_switch_flat').removeClass('active');

    worldMap.controls.enabled = false;

    worldMap.tweenSwitch = new TWEEN.Tween(worldMap.animationProps)
      .to({interpolatePos: 1.0}, Config.viewSwitchDuration)
      .onStart(function() {
        worldMap.hideDisputedAreasBorders();
      })
      .onUpdate(function() {
        worldMap.geometryNeedsUpdate = true;
        // worldMap.updateLines();
      })
      .onComplete(function() {
        //worldMap.controls = worldMap.controlsTrackball;

        worldMap.globe.visible = true;
        worldMap.controls.enabled = true;
        worldMap.viewMode = '3d';
        worldMap.showDisputedAreasBorders();
      })
      .easing(TWEEN.Easing.Cubic.Out)
      .start();

    worldMap.tweenCameraPosition = new TWEEN.Tween(worldMap.camera.position)
      .to({ x: 0, y: 0, z: Config.cameraDistance }, Config.viewSwitchDuration)
      .easing(TWEEN.Easing.Cubic.Out)
      .start();
  });
};


export function initGeneralElements(worldMap) {
  let $this = this;
  $('#country_list').hide();

  /* if(!Config.isTouchDevice) {
    $('#slider_zoom').slider({
      min: 0,
      max: 100,
      value: 0,
      slide: function(event, ui) {
        worldMap.camera.position.setLength( ( 100 - ui.value) / 100 * (worldMap.controls.maxDistance - worldMap.controls.minDistance) + worldMap.controls.minDistance);
      }
    });

    $('#slider_zoom').tipsy({gravity: 's', fade: true, offset: 10});
  } */

  $('#control > #globe-normal').on('click', function() {
    $('#country_list').hide();
    $('#select_city').hide();
    $('#select_city .title').html('Select a City');
    $('#city_list_container > #city_list').html('');
    $('#select_company').hide();
    $('#select_company .title').html('Select a Company');
    $('#company_list_container > #company_list').html('');
    $('#select_country .title').html('Select a Country');
    $('#company .company').html('').hide();
    $('#company .clusterTitle').hide();
    $('#company .cluster').html('').hide();
    $('#company #business-info').addClass('hide');
    $('#company .initial').show();
    $('#control > #globe-normal').hide();
    worldMap.clearBothSelectedCountries();
    worldMap.resetPinColor();
    worldMap.selectedPin = null;
    worldMap.resetCountryColors();
    worldMap.showCenterPins();
    worldMap.resetCamera();
  });

  $('#zoom-in').on('click', function() {
    if(worldMap.cameraDistance > worldMap.controls.minDistance){
      worldMap.cameraDistance -= Config.cameraZoomSpeed;
      worldMap.camera.position.setLength(worldMap.cameraDistance);
    }
  });
  $('#zoom-out').on('click', function() {
    if(worldMap.cameraDistance < worldMap.controls.maxDistance) {
      worldMap.cameraDistance += Config.cameraZoomSpeed;
      worldMap.camera.position.setLength(worldMap.cameraDistance);
    }
  });

  $('.change-companies').on('click', function() {
    $('.buttons a.selected').removeClass('selected');
    $('.change-companies').addClass('selected');

    $('#window > .collaboration').stop(false, true).fadeOut("600", function() {
      $('#window > a').fadeIn(600);
    });

    worldMap.switchMapType('companies');
  });

  $('.change-opportunity').on('click', function() {
    $('.buttons a.selected').removeClass('selected');
    $('.change-opportunity').addClass('selected');

    $('#window > a').stop(false, true).fadeOut("600", function() {
      $('#window > .collaboration').fadeIn(600);
    });

    worldMap.switchMapType('opportunity');
  });

  $('.change-risk').on('click', function() {
    $('.buttons a.selected').removeClass('selected');
    $('.change-risk').addClass('selected');

    $('#window > a').stop(false, true).fadeOut("600", function() {
      $('#window > .collaboration').fadeIn(600);
    });
    

    worldMap.switchMapType('risk');
  });
};

export function hideZoom() {
  if($('#zoom-in').is( ':visible' )) {
    $('#zoom-in').fadeOut(100);
    $('#zoom-out').fadeOut(100);
  }
}

export function showZoom() {
  if(!$('#zoom-in').is( ':visible' )) {
    $('#zoom-in').fadeIn(100);
    $('#zoom-out').fadeIn(100);
  }
}


export function updateCountryTooltip(worldMap, country) {
  // console.log('updateCountryTooltip()');

  /* $('#country-tooltip .details').html('');

  // if(country.name === country.sovereignt) {
  if(country.disputed) {
    $('#country-tooltip .title').html( country.name );
    // $('#country-tooltip .details').html(country.noteBrk);

  } else if(country.type === 'Sovereign country') {
    $('#country-tooltip .title').html( country.name );

  } else {
    $('#country-tooltip .title').html( country.name + ' (' + country.sovereignt + ')' );

  }

  $('#country-tooltip').stop().fadeIn(200); */

};


export function hideCountryTooltip() {
  /* $('#country-tooltip').stop().fadeOut(100); */
};

export function updateModeStatement(worldMap) {
  /* if(!$('#travelscope').is( ':visible' )) {

    $('#travelscope').css('top', '50px');
    $('#travelscope').css('display', 'block');
    $('#travelscope').css('opacity', '0');

    var top = '70px';
    if($(window).width() <= 1100) {
      top = '60px';
    }
    $('#travelscope').animate({
      top: top,
      opacity: 1
    }, {
      easing: 'easeOutCubic',
      duration: 800
    });

    //$('#view_switch').fadeIn(800);

    //$('#slider_zoom').fadeIn(800);
    if($(window).width() > 480) {
      $('#button_country_list').fadeIn(800);
    }
  } */
  if($(window).width() > 480) {
      $('#button_country_list').fadeIn(800);
    }

};

export function createLoadingInfo() {
  $('#country_dropdown').val('Loading ...');
  $('#destination_country_dropdown').val('Loading ...');
  $('#loading .details').html('Loading Visa requirements ...');
  //centerLoadingPanelToScreen();
};


export function updateLoadingInfo(details) {
  $('#loading .details').html(details);
}


export function closeLoadingInfo() {
  $('#loading .details').html('Done.');
  // $('#loading').delay(0).fadeOut(1000);
  $({s: 1}).stop().delay(0).animate({s: 0}, {
    duration: 800,
    easing: 'easeOutCubic',
    step: function() {
      var t = 'scale(' + this.s + ', ' + this.s + ')';
      $('#loading').css('-webkit-transform', t);
      $('#loading').css('-moz-transform', t);
      $('#loading').css('-ms-transform', t);
    },
    complete: function() {
      $('#loading').hide();
    }
  });
}


export function centerLoadingPanelToScreen() {
  $('#loading').css('left', ( ($(window).width() - $('#loading').width()) / 2 - 15 ) + 'px');
  $('#loading').css('top', ( ($(window).height() - $('#loading').height()) / 2 - 25 ) + 'px');
};


export function centerCountryHoverInfoToScreen() {
  /* $('#country-tooltip').css('left', ( ($(window).width() - $('#country-tooltip').width()) / 2 - 15 ) + 'px');
  $('#country-tooltip').css('top', ( ($(window).height() - $('#country-tooltip').height()) / 2 - 25 ) + 'px'); */
};

export function centerCountryHoverInfoToMouse() {
  /* $('#country-tooltip').css('left', (mouse.x - $('#country-tooltip').width() / 2) + 'px');
  $('#country-tooltip').css('top', (mouse.y - $('#country-tooltip').height() / 2 - 100) + 'px'); */
};


export function bindWindowResizeHandler() {
  window.addEventListener('resize', onWindowResize, false);
  onWindowResize();
}


export function bindEventHandlers() {
  var container = $(Config.rendererContainer);

  // container.bind('click', onMouseClick);
  container.single_double_click(onMouseClick, onMouseDoubleClick);

  container.bind('mousedown', onMouseDown);
  container.bind('mousemove', onMouseMove);
  container.bind('mouseup', onMouseUp);

  container.bind('touchstart', onTouchStart);
  container.bind('touchmove', onTouchMove);
  // container.bind('touchend', onTouchEnd);

  container.single_double_tap(onTouchEnd, onDoubleTap);

  onWindowResize();

};


function onWindowResize() {
  //console.log('onWindowResize()');

  // $('#log').css('height', ($(window).height() - 200) + 'px');

  var container = $(Config.rendererContainer);

  var viewportWidth = $('#globe').width();
  var viewportHeight = $('#globe').height();

  container.css('width', viewportWidth + 'px');
  container.css('height', viewportHeight + 'px');

  /* $('#slider_zoom').css('left', (viewportWidth - $('#slider_zoom').width()) / 2 + 'px'); */

  if(worldMap && worldMap.renderer && worldMap.renderer.setSize) {
    let canvas = worldMap.renderer.domElement;
    viewportWidth  = canvas.clientWidth;
    viewportHeight  = canvas.clientHeight;

    worldMap.renderer.setPixelRatio( window.devicePixelRatio );
    worldMap.renderer.setSize( viewportWidth, viewportHeight, false );

    if(Config.usesWebGL) {
      worldMap.renderer.setViewport(0, 0, viewportWidth, viewportHeight);
    }
    worldMap.camera.aspect = viewportWidth / viewportHeight;
    worldMap.camera.updateProjectionMatrix();

    worldMap.render();

    if(uiReady) {
    }
  }

  centerCountryHoverInfoToScreen();
  //centerLoadingPanelToScreen();

  Panels.centerPanelToScreen();

}

function onMouseDown(event) {
  // log('onMouseDown()');

  isMouseDown = true;

  mouseNormalizedTouchStart.copy(mouseNormalized);
  selectCountryOnTouchEnd = true;

}

function onMouseMove(event) {
  // log('onMouseMove()');

  event.preventDefault();

  mouse.x = event.clientX;
  mouse.y = event.clientY;

  var viewportWidth = worldMap.renderer.domElement.clientWidth;
  var viewportHeight = worldMap.renderer.domElement.clientHeight;
  var viewoffsetLeft = worldMap.renderer.domElement.offsetLeft;
  var viewoffsetTop = worldMap.renderer.domElement.offsetTop;

  mouseNormalized.x = ( (event.clientX - viewoffsetLeft) / viewportWidth ) * 2 - 1;
  mouseNormalized.y = -( (event.clientY - viewoffsetTop) / viewportHeight ) * 2 + 1;

  if(isMouseDown) {
    selectCountryOnTouchEnd = mouseNormalized.distanceTo(mouseNormalizedTouchStart) < 0.005;
  }

  if(!worldMap.listHover) {
    centerCountryHoverInfoToMouse();
  }

}

function onMouseUp(event) {
  isMouseDown = false;
}

function onMouseClick(event) {
  // log('onMouseClick()');

  $('#country_dropdown').blur();
  $('#destination_country_dropdown').blur();
  /* $('#slider_zoom .ui-slider-handle').blur(); */

  if(selectCountryOnTouchEnd) {
    worldMap.selectPinFromMap(event);
  }

}

function onMouseDoubleClick(event) {
  // log('onMouseDoubleClick()');
}

function onTouchStart(event) {
  // log('onTouchStart');
  event.preventDefault();

  var viewportWidth = worldMap.renderer.domElement.clientWidth;
  var viewportHeight = worldMap.renderer.domElement.clientHeight;
  var viewoffsetLeft = worldMap.renderer.domElement.offsetLeft;
  var viewoffsetTop = worldMap.renderer.domElement.offsetTop;

  var touch = event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
  mouseNormalized.x = ( (touch.pageX - viewoffsetLeft) / viewportWidth ) * 2 - 1;
  mouseNormalized.y = -( (touch.pageY - viewoffsetTop) / viewportHeight ) * 2 + 1;

  mouseNormalizedTouchStart.copy(mouseNormalized);

  selectCountryOnTouchEnd = true;

}

function onTouchMove(event) {
  // log('onTouchMove');
  event.preventDefault();

  var touch = event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];

  mouse.x = touch.pageX;
  mouse.y = touch.pageY;

  var viewportWidth = worldMap.renderer.domElement.clientWidth;
  var viewportHeight = worldMap.renderer.domElement.clientHeight;
  var viewoffsetLeft = worldMap.renderer.domElement.offsetLeft;
  var viewoffsetTop = worldMap.renderer.domElement.offsetTop;

  mouseNormalized.x = ( (touch.pageX - viewoffsetLeft) / viewportWidth ) * 2 - 1;
  mouseNormalized.y = -( (touch.pageY - viewoffsetTop) / viewportHeight ) * 2 + 1;

  if(mouseNormalized.distanceTo(mouseNormalizedTouchStart) > 0.03) {
    selectCountryOnTouchEnd = false;
  }

}

function onTouchEnd(event) {
  // log('onTouchEnd');
  event.preventDefault();

  var viewportWidth = worldMap.renderer.domElement.clientWidth;
  var viewportHeight = worldMap.renderer.domElement.clientHeight;
  var viewoffsetLeft = worldMap.renderer.domElement.offsetLeft;
  var viewoffsetTop = worldMap.renderer.domElement.offsetTop;

  var touch = event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
  mouseNormalized.x = ( (touch.pageX - viewoffsetLeft) / viewportWidth ) * 2 - 1;
  mouseNormalized.y = -( (touch.pageY - viewoffsetTop) / viewportHeight ) * 2 + 1;

  if(selectCountryOnTouchEnd) {
    worldMap.selectPinFromMap(event);
  }

}

function onDoubleTap(event) {
  // log('onDoubleTap()');
}
